export const INSTAGRAM_URL = "https://www.instagram.com/labelriteshpuri/?hl=en";
export const WHATSAPP_URL = "https://wa.me/919834704067";
export const SUPPORT_EMAIL = "mailto:riteshpuri718@gmail.com";
export const TWITTER_URL = "https://www.instagram.com/realriteshpuri/?hl=en";
export const PINTEREST_URL = "https://wa.me/919834704067";
export const YOUTUBE_URL = "https://www.youtube.com/@riteshpuriofficial";
export const FACEBOOK_URL = "mailto:riteshpuri718@gmail.com";

